<template>
  <v-container
    fluid
    class="content fill-height"
  >
    <v-row
      no-gutters
      justify="space-between"
      class="content__row"
    >
      <v-col
        md="7"
        sm="100%"
        class="pa-5 content__col-result"
      >
        <v-card
          v-if="currentCertId"
          flat
          class="fill-height content__col-result__card"
        >
          <v-expansion-panels
            v-model="panelStates"
            flat
            multiple
          >
            <ResultTable
              :data-arr="currentCert.info.main"
              title="Основная информация"
            />
            <ResultTable
              :data-arr="currentCert.info.certificate"
              title="Информация о сертификате"
              :download-arr="currentCert.download"
            />
            <ResultTable
              v-for="plugin in currentCert.info.plugins"
              :key="plugin.id"
              :data-arr="plugin.data"
              :title="plugin.title"
            />
          </v-expansion-panels>
        </v-card>
        <v-card
          v-else
          flat
          class="pa-7 fill-height d-flex align-center justify-center"
        >
          <p class="text-center mb-0">
            Для этого файла результаты отсутствуют
          </p>
        </v-card>
      </v-col>
      <v-col
        md="5"
        sm="100%"
        class="fill-height pa-5 content__col-doclist"
      >
        <ResultFileList
          certificate
          :data="resultData"
          :selected-id="currentCertId"
          list-title="Список сертификатов"
          @documentClick="onDocClick"
          @resetAll="doReset"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ResultFileList from '@/components/ResultFileList'
import ResultTable from '@/components/ResultTable'
import { mapActions, mapState } from 'vuex'
import { isArray } from '@/helpers/helpers'
import { delay } from 'lodash'

export default {
  name: 'CertificateResultPage',
  components: {
    ResultTable, ResultFileList
  },

  data () {
    return {
      currentCertId: '',
      appColor: this.$appConfig.color,
      panelStates: []
    }
  },

  computed: {
    ...mapState({
      resultData: state => state.certificate.resultData
    }),

    currentCert () {
      const doc = this.resultData.find(item => item.id === this.currentCertId)
      if (!doc) {
        return { title: 'unknown', status: false, info: null }
      }
      return doc
    }
  },

  beforeMount () {
    if (isArray(this.resultData)) {
      this.currentCertId = this.resultData[0].id

      delay(this.openPanels, 300)
    }
  },

  methods: {
    ...mapActions(['resetStateByType']),

    onDocClick (id) {
      this.currentCertId = id
    },

    doReset () {
      this.resetStateByType('certificate')
    },

    openPanels () {
      const certificateInfo = this.currentCert.info
      let indexToAdd = 0

      try {
        for (const infoKey in certificateInfo) {
          if (infoKey === 'plugins' && certificateInfo.plugins?.length) {
            // eslint-disable-next-line no-unused-vars
            for (const pluginKey in certificateInfo.plugins) {
              this.panelStates.push(indexToAdd++)
            }
          } else {
            this.panelStates.push(indexToAdd++)
          }
        }
      } catch (e) {
        console.warn('Не удалось сформировать panelStates', e)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .content {
    padding: 20px 5vw;

    @media(max-width: $cp-laptop-breakpoint) {
      padding: 20px 0;
    }

    @media(max-width: $cp-mobile-breakpoint) {
      display: block;
    }

    &__title {
      @media(max-width: $cp-mobile-breakpoint) {
        font-size: 0.9rem;
      }
    }

    &__row {
      height: 100%;

      @media(max-width: $cp-mobile-breakpoint) {
        display: flex;
        flex-direction: column-reverse;
        flex-grow: initial;
        align-items: center;
      }
    }

    &__col-result {
      @media(max-width: $cp-mobile-breakpoint) {
        flex-basis: auto;
        flex-grow: 1;
      }

      &__card {
        background-color: transparent;
      }
    }

    &__col-doclist {
      @media(max-width: $cp-mobile-breakpoint) {
        flex-basis: 0;
        flex-grow: 0;
      }
    }
  }
</style>
